import axios from 'axios'

const instance = axios.create({
  baseURL: `//puzzle.mead.io`
})

export const fetchPuzzle = async (wordCount) => {
  const response = await axios.get(`${instance}/puzzle?wordCount=${wordCount}`)

  if (response.status === 200) {
    const data = response.json()
    return data.puzzle
  } else {
    throw new Error('Unable to get puzzle')
  }
}

export default instance

// /puzzle?wordCount=${wordCount}